@use '@/styles/tokens' as *;

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.topRow {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
}

.titleGroup {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

.back {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  color: $color-neutral-950;
}

.name {
  margin: 0;
  min-width: 0;
  overflow: hidden;
  font-family: $font-family-heading;
  font-size: 24px;
  font-weight: 500;
  color: $color-neutral-950;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Empty top-right slot reserved for ticket 07's More-options menu. */
.actions {
  flex: 0 0 auto;
  min-width: var(--space-4);
  display: flex;
  align-items: center;
  color: $color-neutral-600;
}
